export default {
  // TITLE
  TitleControl: '',
  ShowTitleControl: { checked: true },
  StyleTitleControl: {
    fontSize: 20,
    color: '#000000',
    fontFamily: 'arial',
    bold: false,
    italic: false,
    underline: false,
    align: 'center',
  },
  // GENERAL
  SortValuesControl: 'Não ordenado',
  CustomSortControl: {
    checked: false, kpiCategories: [],
  },
  SortDataControl: 'Não ordenado',
  ColumnToSortControl: '',
  ColumnSize: 'auto',
  ColumnWidth: 50,
  RunningText: false,
  // LABEL
  LabelsFontFamilyControl: { value: 'arial' },
  LabelsFontSizeControl: { value: 14 },
  LabelAlignLeft: [],
  LabelAlignRight: [],
  LineColorControl: 'single',
  RowColor: 'white',
  StripedRowsColor: 'white',
  HeaderColor: 'white',
  ValueFormatControl: 'locale',
  UseGlobalColor: true,
  UseGlobalFont: true,
  // AXIS
  EnableGridX: true,
  EnableGridY: true,
  GridColor: '#EEE',
};
